import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import { OrganizationAPIService } from 'wflow-main-app/src/app/core/api/api/organization';
import { OrganizationModel } from '../../core/api/model/organization/organization-model';
import { OrganizationSettings } from '../../core/api/model/organization/organization-settings';
import * as SettingsActions from './settings.actions';
import { LoadSettings } from './settings.actions';

@Injectable()
export class SettingsEffects {
  readonly loadSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadSettings),
      mergeMap((payload: { orgId: string }) =>
        combineLatest([
          this.organizationService.getCurrentOrganization(payload?.orgId),
          this.organizationService.getOrganizationSettings(payload?.orgId),
        ]).pipe(
          take(1),
          map(([org, settings]) =>
            SettingsActions.LoadSuccessSettings({
              id: payload?.orgId,
              data: {
                ...org,
                ...settings,
              } as OrganizationModel & OrganizationSettings,
            }),
          ),
          catchError((error) =>
            of(
              SettingsActions.SetFailureSettings({
                orgId: payload?.orgId,
                error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private organizationService: OrganizationAPIService,
  ) {}
}
